var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/forgot-password/buttons.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"forgotPassword")),"showPasswordResetSent")) {
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "\n\n        <div class=\"o-row o-column o-extra-small--12\">\n\n            ";
var t_1;
t_1 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "originalURL"),(lineno = 9, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "homepageUrl"), "homepageUrl", context, [])));
frame.set("destination", t_1, true);
if(frame.topLevel) {
context.setVariable("destination", t_1);
}
if(frame.topLevel) {
context.addExport("destination", t_1);
}
output += "\n\n            <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "destination"), env.opts.autoescape);
output += "\" class=\"c-button-primary c-modal-form__button\" data-qa-continue-shopping>\n                ";
output += runtime.suppressValue((lineno = 12, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-continue_shopping",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n            </a>\n\n        </div>\n\n    ";
;
}
else {
output += "\n\n        <div class=\"o-row o-column o-extra-small--12\">\n\n            <button class=\"c-button-primary c-modal-form__button js-modal__cancel\" data-qa-continue-shopping>\n                ";
output += runtime.suppressValue((lineno = 22, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-continue_shopping",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n    ";
;
}
output += "\n\n";
;
}
else {
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "\n\n        <div class=\"o-row o-column o-extra-small--12 u-margin-top\">\n\n            <button class=\"c-button-primary c-modal-form__button\" type=\"submit\" data-qa-forgot-password-submit>\n                ";
output += runtime.suppressValue((lineno = 36, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_submit",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n    ";
;
}
else {
output += "\n\n        <div class=\"o-row o-column o-extra-small--12 o-small--8\">\n\n            <button class=\"c-button-primary c-modal-form__button\" type=\"submit\" data-qa-forgot-password-submit>\n                ";
output += runtime.suppressValue((lineno = 46, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_submit",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n        <div class=\"o-column o-extra-small--12 o-small--4 c-modal-login__button-cancel\">\n\n            <div class=\"c-form__field\">\n\n                <button class=\"c-button-text c-button-text--adjacent c-modal-form__cancel js-modal__cancel\" data-qa-forgot-password-cancel>\n                    ";
output += runtime.suppressValue((lineno = 56, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_cancel",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </button>\n\n            </div>\n\n        </div>\n\n    ";
;
}
output += "\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/forgot-password/buttons.j2"] , dependencies)